import { render, staticRenderFns } from "./PortletSecurityPosture.vue?vue&type=template&id=2540f236&scoped=true"
import script from "./PortletSecurityPosture.vue?vue&type=script&lang=js"
export * from "./PortletSecurityPosture.vue?vue&type=script&lang=js"
import style0 from "./PortletSecurityPosture.vue?vue&type=style&index=0&id=2540f236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2540f236",
  null
  
)

export default component.exports